





















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ILoginThreshList } from '@/store/home/stats/types';
import DataTable from '../../common/DataTable.vue';

const Stats = namespace('home/stats');

@Component({
  components: { DataTable },
})
export default class LoginExceptionTable extends Vue {
  @Stats.State('loginThreshList') public list!: ILoginThreshList;

  public orgHeaders = [
    { text: '组织名称', value: 'orgName' },
    { text: '总人数', value: 'totalCount' },
  ];
  public userHeaders = [
    { text: '用户名称', value: 'userName' },
    { text: '总次数', value: 'totalCount' },
  ];

  // 按组织统计
  public get orgItems() {
    return this.list.data.filter((item) => item.type === 1);
  }

  // 按用户统计
  public get userItems() {
    return this.list.data.filter((item) => item.type === 2);
  }
}
